import React from 'react';
import { useField } from 'formik';
import { Form } from "react-bootstrap";

const AppSelectField = ({ label, options, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <>
      <Form.Select {...field} {...props}>
        {label && (
          <option value="" label={label} />
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value} label={option.label} />
        ))}
      </Form.Select>
      {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </>
  );
};

export default AppSelectField;
